import { gql } from 'graphql-tag'

const staffingPlanFragment = gql`
  fragment StaffingPlanFragment on StaffingPlan {
    totalIncentivesTarget
    totalThumbablesTarget
    roster {
      user {
        id
        name
      }
      startTime
      endTime
      position
      responsibility
      salesIncentiveTarget
      thumbsUpTarget
      salesIncentiveActual
      thumbsUpActual
      note
      breaks
    }
  }
`
export const getStaffingPlan = gql`
  query GetStaffingPlan($stationId: ID!, $date: String!, $mode: StaffPlanMode!) {
    staffPlan(stationId: $stationId, date: $date, mode: $mode) {
      id
      date
      roster {
        user {
          id
          name
        }
        startTime
        endTime
        position
        responsibility
        salesIncentiveTarget
        thumbsUpTarget
        thumbsUpActual
        salesIncentiveActual
        note
      }
    }
  }
`

export const getStaffingPlanWithAdditionalInfo = gql`
  query GetStaffingPlanWithAdditionalInfo(
    $stationId: ID!
    $date: String!
    $mode: StaffPlanMode!
    $status: AssignmentStatusEnum!
  ) {
    staffPlan(stationId: $stationId, date: $date, mode: $mode) {
      id
      date
      roster {
        user {
          id
          name
        }
        startTime
        endTime
        startDateTime
        endDateTime
        position
        responsibility
        salesIncentiveTarget
        thumbsUpTarget
        thumbsUpActual
        salesIncentiveActual
        note
      }
    }
    stationActivityDescriptions(stationId: $stationId) {
      id
      name
      description
    }
    assignments(stationId: $stationId, status: $status) {
      total
      edges {
        node {
          __typename
          id
          subject
          description
          assignee {
            id
            name
          }
          assignees {
            id
            name
          }
          deadline
          status
          comment
          doneAt
        }
      }
    }
    reservations(stationId: $stationId, date: $date) {
      id
    }
  }
`

export const increaseSalesIncentiveProduct = gql`
  mutation IncreaseSalesIncentiveProduct(
    $userId: ID!
    $amount: Float!
    $unit: SalesIncentiveUnit!
    $salesIncentiveProductId: ID
    $name: String
    $date: String # TODO: Remove, date is calculated in backend
    $stationId: ID!
  ) {
    increaseSalesIncentiveCard(
      userId: $userId
      amount: $amount
      unit: $unit
      salesIncentiveProductId: $salesIncentiveProductId
      name: $name
      date: $date # TODO: Remove, date is calculated in backend
      stationId: $stationId
    ) {
      id
      amount
      date
    }
  }
`

export const increaseThumbsUpCard = gql`
  mutation IncreaseThumbsUpCard($userId: ID!, $thumbsUpItemId: ID!, $date: String, $stationId: ID!) {
    increaseThumbsUpCard(userId: $userId, thumbsUpItemId: $thumbsUpItemId, date: $date, stationId: $stationId) {
      id
      amount
      date
    }
  }
`

export const updateEmplyeeNote = gql`
  mutation updateDailyEmployee($stationId: ID!, $userId: ID!, $date: String, $note: String) {
    updateDailyEmployee(stationId: $stationId, userId: $userId, date: $date, note: $note) {
      id
      date
      ...StaffingPlanFragment
    }
  }
  ${staffingPlanFragment}
`
